import { Select, Text } from '@components';
import { ILane, RateCardType } from '@types';
import styles from './RateCard.module.scss';
import AddIcon from '@mui/icons-material/Add';

type TAddRateCardDropdownProps = {
	onAddRateCardType: ({
		rateCardType,
		itemId
	}:{
		rateCardType: RateCardType;
		itemId?: string;
	}) => void;
	possibleRateCardTypes: {
		itemId?: string;
		key:string;
		label: string
	}[];
	rateCard: ILane | null;
	isDisabled?: boolean;
}


export const AddRateCardDropdown = (props: TAddRateCardDropdownProps) => {
	const {
		onAddRateCardType,
		possibleRateCardTypes,
		rateCard,
		isDisabled = false
	} = props;

	const handleSelectClick = (value: string) => {
		if (!['WEIGHT', 'PALLETS', 'FULL_LOAD', 'CPK'].includes(value)) {
			onAddRateCardType({
				rateCardType: 'ITEM',
				itemId: value
			})
			return
		}
		onAddRateCardType({ rateCardType: value as RateCardType })
	}

	const rcToAdd = possibleRateCardTypes.map((rc) => {
		if (!rateCard?.rate_cards.find((ratecard) => {
			if (rc.itemId) return ratecard.item_definition?.item_id === rc.itemId
			return ratecard.type === rc.key
		})) {
			return rc
		}
		return null
	}).filter((rc) => rc !== null);
	return (
		<Select
			value={undefined}
			onChange={handleSelectClick}
			name={''}
			looksLikeAButton={true}
			buttonLabel={'Add Rate Card'}
			placeholder=''
			displayThin
			disabled={isDisabled || rcToAdd.length === 0}
		>
			{
				rcToAdd.map((rc) => {
					return <Select.Option value={rc.itemId ?? rc.key} key={rc.key}>
						<span className={styles.option}>
							<Text>
								{rc.label}
							</Text>
							<AddIcon className={styles.optionIcon} height={4} width={4} />
						</span>
					</Select.Option>
				})
			}
		</Select>
	)
}